import { connect } from 'react-redux';
import { confirmVerifyArtifactApplication, modal as modalActions } from './../actions';
import ConfirmationModalComponent from './../Components/ConfirmationModalComponent';
import { owners } from '../helpers/modals';
import { getModalInfoByOwner, getModalVisibility } from './../reducers';

export const mapStateToProps = (state) => {
  const modalInfo = getModalInfoByOwner(state, owners.verifyArtifactApplication);
  const visible = getModalVisibility(state, owners.verifyArtifactApplication);
  const title = `Confirm Verify Artifact Application for ${modalInfo.name}`;
  const confirmText = 'Confirm';
  const cancelText = 'Cancel';
  const bodyText = 'This operation will mark the new ' +
    'version of the application as verified, as well as ' +
    'copy the Last Diffed Version file to the supported directory';
  return {
    visible,
    title,
    confirmText,
    cancelText,
    bodyText,
    eventProps: { applicationInfo: modalInfo }
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onCancel: () => dispatch(modalActions.showVerifyArtifactApplicationModal(false)),
    onConfirm: (eventProps) => {
      dispatch(confirmVerifyArtifactApplication(eventProps.applicationInfo));
      dispatch(modalActions.showVerifyArtifactApplicationModal(false));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModalComponent);


// WEBPACK FOOTER //
// src/Containers/VerifyArtifactApplicationModalContainer.jsx